"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorOptimizeQueryOperationRewriteCopy = void 0;
const bus_optimize_query_operation_1 = require("@comunica/bus-optimize-query-operation");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
/**
 * A comunica Rewrite Copy Optimize Query Operation Actor.
 */
class ActorOptimizeQueryOperationRewriteCopy extends bus_optimize_query_operation_1.ActorOptimizeQueryOperation {
    constructor(args) {
        super(args);
    }
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const factory = new utils_algebra_1.AlgebraFactory(dataFactory);
        const operation = utils_algebra_1.algebraUtils.mapOperation(action.operation, {
            [utils_algebra_1.Algebra.Types.COPY]: {
                preVisitor: () => ({ continue: false }),
                transform: (operationOriginal) => {
                    // No-op if source === destination
                    if ((typeof operationOriginal.destination === 'string' && typeof operationOriginal.source === 'string' &&
                        operationOriginal.destination === operationOriginal.source) ||
                        (typeof operationOriginal.destination !== 'string' && typeof operationOriginal.source !== 'string' &&
                            operationOriginal.destination.equals(operationOriginal.source))) {
                        return factory.createCompositeUpdate([]);
                    }
                    // COPY is equivalent to drop destination, and add
                    return factory.createCompositeUpdate([
                        factory.createDrop(operationOriginal.destination, true),
                        factory.createAdd(operationOriginal.source, operationOriginal.destination, operationOriginal.silent),
                    ]);
                },
            },
        });
        return { operation, context: action.context };
    }
}
exports.ActorOptimizeQueryOperationRewriteCopy = ActorOptimizeQueryOperationRewriteCopy;
//# sourceMappingURL=ActorOptimizeQueryOperationRewriteCopy.js.map